// src/config/seasonalConfig.ts
// ★ Configurable date ranges for seasonal themes.
// Adjust these to control when each theme activates automatically.

export type Season = 'default' | 'halloween' | 'christmas';

export interface SeasonDateRange {
    season: Season;
    /** Start month (1-indexed), day */
    start: { month: number; day: number };
    /** End month (1-indexed), day */
    end: { month: number; day: number };
}

/**
 * Seasonal date ranges — checked in order, first match wins.
 * Dates are inclusive.
 */
export const SEASON_DATE_RANGES: SeasonDateRange[] = [
    {
        season: 'halloween',
        start: { month: 10, day: 24 }, // Oct 24
        end: { month: 11, day: 1 },    // Nov 1
    },
    {
        season: 'christmas',
        start: { month: 12, day: 15 }, // Dec 15
        end: { month: 1, day: 2 },     // Jan 2 (wraps around year)
    },
];

/**
 * Determine the active season for a given date.
 */
export function getActiveSeason(date: Date = new Date()): Season {
    const month = date.getMonth() + 1; // 1-indexed
    const day = date.getDate();

    for (const range of SEASON_DATE_RANGES) {
        const { start, end } = range;

        // Handle year-wrapping (e.g. Dec 15 → Jan 2)
        if (start.month > end.month) {
            if (
                (month > start.month || (month === start.month && day >= start.day)) ||
                (month < end.month || (month === end.month && day <= end.day))
            ) {
                return range.season;
            }
        } else {
            // Normal range within same year
            const afterStart = month > start.month || (month === start.month && day >= start.day);
            const beforeEnd = month < end.month || (month === end.month && day <= end.day);
            if (afterStart && beforeEnd) {
                return range.season;
            }
        }
    }

    return 'default';
}
